/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import _, { debounce } from 'lodash';
import PickerManager from '@/shared/tools/pickerManager';
import RouterHelper from '@/shared/utils/routerHelper';
import LoginUtil from '@/viewsH5/login/LoginUtils';

import VueRouter, { RawLocation, Route } from 'vue-router';
import { Dialog, ThemeManager } from '@hb/coffee';
import { isH5App, isIPOrigin, LOGIN_FUNNEL_SUPPORT_VERSION } from '@/constant';
import { session } from '@/shared/utils/storage';
import { RouterH5Enum, RouterV2Enum } from '@/router/router-names';
import { Vue } from 'vue-property-decorator';
import platform from '@/shared/utils/platform';
import { abortRequest } from '@/shared/utils/request';

import {
  setPageTitle, setNativeNavBar, getPlatformDeviceInfo,
  closeWebView,
} from '@/api/native/utils';

import store, { updateModuleState } from '@/store';
import { getTokenAndKey } from '@/api/native/userInfo';
import URLUtils from '@/shared/utils/URLUtils';
import Bootstrap, { appVersion } from '@/shared/utils/bootstrap';
import { jumpToNewLoanMarketH5, jumpToNewVersion } from '@/shared/utils/jumpTo';
import { getGalileoAb } from '@/shared/galileoAb';
import { versionCompare } from '@/shared/utils/versionCompare';
import { landData } from '@/shared/utils/landData';
import wechat, { isFinanceWechatMini } from '@/api/native/wechat';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { AbTestEnum } from '@/api/user/types';
import { skNativeContainer, skNativeContainerOpen } from '@/api/native/container';
import { cache } from '../shared/decorators/cache';
import { popPageManager } from '../shared/tools/popPageManager';
import { Loading } from '../shared/utils/loading';
import {
  getPageIdByUser, ubtModuleExposeNew, ubtPage,
} from '../shared/utils/ubt';
import isPrerendering from '../shared/utils/isPrerendering';
import { HOME_ALL_VERSION_ROUTE_PATHS } from './utils';

type NavigationGuardNextType = (
  to?: RawLocation | false | ((vm: Vue) => unknown) | void
) => void;

// 针对浏览器环境进行拦截
const addH5BeforeEachGuard = (router: VueRouter): void => {
  const LoginBackPath = 'LoginBackPath';

  // 浏览器环境路由排查是否登录
  if (!isPrerendering()) {
    router.beforeEach(
      async (to: Route, from: Route, next: NavigationGuardNextType) => {
        if (isH5App) {
          const q = URLUtils.getQueryMap();
          const originToQuery = to.query;
          const newQuery = JSON.parse(JSON.stringify(originToQuery));
          if (q.sms) {
            // sms 有值时，删除 query sms属性
            delete newQuery.sms;
            // 短信营销场景，未安装 app 用户，访问跳转营销页下载--并直接触发下载app逻辑
            RouterHelper.useNextFalse(next);
            router.replace({
              path: RouterV2Enum.smsDownload,
              query: newQuery,
            });
            return;
          }

          /** 兜底拦截：若是返回至首页，则需调用微信sdk回退至小程序的首页 */
          if (to.name === RouterV2Enum.home && isFinanceWechatMini()) {
            wechat.backToHome();
          }

          const {
            ciphertext,
          } = URLUtils.getQueryMap();
          // h5要求登录并且未登录的页面
          // meta 一开始无值，后面才有值，需要处理,不然不需要登录的页面 也去登录了，bug
          // 链接上有 ciphertext 参数时，需要重新获取最新 金融用户token
          const isNeedLoginButNotLogined = Object.keys(to.meta).length !== 0
            && to.meta.needLogin !== false && (!LoginUtil.isLogin() || ciphertext);
          if (isNeedLoginButNotLogined) {
            // 钉钉H5场景 未登录时（链接上带三要素时），做授权登录逻辑
            if (platform.isDingTalk) {
              await Bootstrap.throughGate();
              // 未登录金融账号时，return
              if (!LoginUtil.isLogin()) {
                return;
              }
            } else if (platform.isWechatMini) {
              if (isFinanceWechatMini()) {
                wechat.redirectToLogin();
              }
            } else {
              session.set(LoginBackPath, { path: to.fullPath });
              RouterHelper.useNextFalse(next);
              LoginUtil.login();
              return;
            }
          }

          // 处理登录回跳
          if (from.name === RouterH5Enum.loginSms && !/login/.test(to.path)) {
            const loginBackPath: {
              path: string;
              lock?: boolean;
            } = session.get(LoginBackPath) || {
              path: '/',
            };

            if (loginBackPath.lock === undefined) {
              loginBackPath.lock = true;
              session.set(LoginBackPath, loginBackPath);

              next(loginBackPath.path);

              if (LoginUtil.cb) {
                LoginUtil.cb();
              }

              return;
            }
          }
        }
        next();
      },
    );
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let confirmDialog: any | null = null;
const shouldConfirmOnBack: Dictionary<boolean> = {};

/**
 * TODO: 注意： 不要直接使用next(false), 可以用RouterHelper.useNextFalse(next)替代
 */
const addBeforeEachGuard = (router: VueRouter): void => {
  // 此处是为了解决安卓容器化的兼容问题例如身份证清晰分不足跳转
  const routerReplace = router.replace.bind(router);
  const routerPush = router.push.bind(router);
  router.replace = async (to: RawLocation) => {
    const isNativeContainer = await skNativeContainer();
    /** 在容器化中，如果涉及到首页开始跳转的场景，需要判断是跳转首页还是其他页面进行针对处理 */
    if (isNativeContainer && router.currentRoute.path?.includes(RouterV2Enum.home)) {
      const path = typeof to === 'string' ? to : to.path;
      if (path && !path.includes(RouterV2Enum.home)) {
        return routerPush(to);
      }
      if (path && path.includes(RouterV2Enum.home)) {
        return routerReplace(to);
      }
    }
    return routerReplace(to);
  };


  router.beforeEach(async (to, from, next) => {
    /** 清除当前页面 - AbortController集合 */
    abortRequest();
    /** 哈啰出行App，参与主题切换 */
    if (platform.isHelloApp || isIPOrigin) {
      /** 路由切换时，调整主题类型 */
      store.dispatch('base/getExperimentPageThemeType').catch(() => {
        // 静默处理错误
      });
    }

    // 控制页面私有主题，防止与其它样式变量冲突
    ThemeManager.setThemeScope(to.path || '');

    // 是否强制回退到首页，主要用于新项目回退至首页的场景
    if (to.query.needBackHome) {
      RouterHelper.setBackPath(RouterV2Enum.home);
      return RouterHelper.useNext(next, to, from);
    }

    // 如果配置了回退路由，则直接回退至目标路由
    // 使用场景：新项目回退到老项目首页场景
    if (to.query.back) {
      RouterHelper.navigate(to.query.back);
      return RouterHelper.useNextFalse(next);
    }

    const {
      needLogin, isShowH5Nav = false, newRedirect, newRedirectReplace = false,
    } = to.meta;
    // 是否投放场景
    const isMarket = landData.getSouce().includes('f_toufang');

    // 运行在app和小程序下且页面需要登陆，跳转登陆页
    // 页面配置需要登陆和 无配置的情况下默认登陆
    if ((needLogin || (needLogin === undefined))
      && (platform.isHelloApp || platform.isAlipayMini || platform.isWechatMini)) {
      try {
        let toufangParams;
        if (isMarket) {
          toufangParams = {
            business: 'finance',
            pageId: to.meta.pageId,
            source: landData.getSouce(),
          };
        }
        await getTokenAndKey(true, toufangParams);
      } catch (error) {
        // IOS 进入登录页会进入catch 方法
      } finally {
        // 异常抛出
        let platformDeviceInfoBridge = {};
        const { token, platformDeviceInfo } = store.state.base || {};
        // 哈罗app承接链路场景中，需要记录clientId
        if (platform.isHelloApp
          && isMarket
          && !token
          && versionCompare(appVersion, LOGIN_FUNNEL_SUPPORT_VERSION) >= 0) {
          try {
            // 设备信息不存在的时候再去调用
            if (!Object.keys(platformDeviceInfo).length) {
              platformDeviceInfoBridge = await getPlatformDeviceInfo();
              await updateModuleState('base', {
                platformDeviceInfo: platformDeviceInfoBridge,
              });
            }
          } catch (e) {
            // console.error(`调用设备信息失败${e}`);
          }
          // 获取用户信息失败，调起登录前调用
          ubtModuleExposeNew(
            to.meta.pageId,
            'finance_quickEdit_call_login',
            {
              ...store.state.base.platformDeviceInfo,
            },
          );
        }
      }
    }

    let canRedirect = false;
    /** 贷超新主体实验结果 */
    let newLoanMarketAbRes = false;
    const { isExternalPlacement } = to.query || {};

    // TODO: 由于钉钉环境涉及到联登逻辑，因此暂时屏蔽该环境的灰度计划
    if (!platform.isDingTalk) {
      // 外投场景直接走重构项目，无需ab;

      if (isExternalPlacement === 'true') {
        canRedirect = true;
      } else {
        if (to.meta.newAb) {
          // 独立 app 场景 不走 ab，直接走重构
          if (platform.isSkApp) {
            canRedirect = true;
          } else {
            const { defaultVersionId, experimentId } = to.meta.newAb || {};
            const storeAbRes = store.state.base.abRes.get(experimentId);
            /** 是否是贷超新主体实验 */
            const isNewLoanMarket = newRedirect === NewVersionEnum.LOAN_MARKET;

            if (storeAbRes) {
              canRedirect = (storeAbRes as { isNewVersion: string }).isNewVersion === String(true);
              // 命中实验后，判断是否是贷超主体迁移实验
              newLoanMarketAbRes = (storeAbRes as { result: string })
                .result === AbTestEnum.waitHint && isNewLoanMarket;
            } else {
              const abRes = await getGalileoAb().getAbResCatchError(experimentId, defaultVersionId);
              canRedirect = abRes && abRes.isNewVersion === String(true);
              // 命中实验后，判断是否是贷超主体迁移实验
              newLoanMarketAbRes = abRes && abRes.result === AbTestEnum.waitHint && isNewLoanMarket;
              updateModuleState('base', {
                experimentId: abRes,
              });
            }
            // 贷超页面默认跳转新项目，不受实验影响
            if (isNewLoanMarket) {
              canRedirect = true;
            }
          }
        } else {
          // 非 ab 场景，配置了新项目路由的 都要跳转新项目
          canRedirect = true;
        }
      }
    }

    // 是否外采授信审核页参数，不跳新项目
    const { sourceOrderId } = to.query;
    if (newRedirect && canRedirect && !sourceOrderId) {
      // 解决跳转新项目导航栏抖动问题
      if (isShowH5Nav && !platform.isAliMP && !platform.isWechatMini) {
        setNativeNavBar(false);
      }
      const query = to.fullPath.split('?');
      if (newLoanMarketAbRes) {
        // 如果命中贷超主体迁移的实验，就跳转贷超新主体页面
        jumpToNewLoanMarketH5(newRedirect, newRedirectReplace,
          query.length > 1 ? query[1] : '');
      } else {
        jumpToNewVersion(newRedirect, newRedirectReplace,
          query.length > 1 ? query[1] : '');
      }
      return RouterHelper.useNextFalse(next);
    }

    // 避免出现返回弹窗时，导航栏 title 异常
    document.title = (from.meta && from.meta.title) || '臻有钱';
    PickerManager.closeAllPicker();

    const isBack = RouterHelper.isBackOnce();
    const shouldConfirmOnBackKey = `${from.path}_${to.path}`;

    // 默认是需要做返回拦截
    if (typeof shouldConfirmOnBack[shouldConfirmOnBackKey] === 'undefined') {
      shouldConfirmOnBack[shouldConfirmOnBackKey] = true;
    }

    // 如果不是从新项目回退的场景，再触发挽留弹窗逻辑
    if (isBack) {
      if (Loading.isLoading) {
        // loading中无效，不允许跳转，旧逻辑，需要重构
        return RouterHelper.useNextFalse(next);
      }

      // 有弹出页面，就关了弹出页面
      if (popPageManager.hasOpenedPopPage()) {
        popPageManager.saveOrCloseOpendPop();
        return RouterHelper.useNextFalse(next);
      }

      // 有返回确认窗口，就返回确认
      const backConfirmConfig = RouterHelper.backConfirmConfig === 'default'
        ? from.meta.backConfirmDialog
        : RouterHelper.backConfirmConfig;

      if (confirmDialog) {
        Dialog.close();
        confirmDialog = null;
      } else if (backConfirmConfig && shouldConfirmOnBack[shouldConfirmOnBackKey]) {
        ((targetPath) => {
          confirmDialog = Dialog.confirm({
            closeOnPopstate: false,
            closeable: false,
            ...backConfirmConfig,
          })
            .then(() => {
              if (backConfirmConfig.beforeConfirm) {
                backConfirmConfig.beforeConfirm();
              }

              confirmDialog = null;

              delete shouldConfirmOnBack[shouldConfirmOnBackKey];
            })
            .catch(async () => {
              if (backConfirmConfig.beforeCancel) {
                backConfirmConfig.beforeCancel();
              }

              confirmDialog = null;
              const isNativeContainer = await skNativeContainer();
              const isNativeContainerOpen = await skNativeContainerOpen();
              // 在安卓容器化中，由于跳出了容器化，导致回退首页时需要关闭新容器回到容器化中
              if (!isNativeContainer
                && isNativeContainerOpen
                && platform.isAndroid) {
                await closeWebView();
              } else {
                RouterHelper.backToPath(targetPath);
              }
            });
          // confirm 弹窗打开时
          if (backConfirmConfig.dialogOpend) {
            backConfirmConfig.dialogOpend();
          }
        })(to.path);

        shouldConfirmOnBack[shouldConfirmOnBackKey] = false;
        return RouterHelper.useNextFalse(next);
      }

      if (typeof shouldConfirmOnBack[shouldConfirmOnBackKey] !== 'undefined') {
        delete shouldConfirmOnBack[shouldConfirmOnBackKey];
      }

      let backPath = RouterHelper.backPathConfig === 'default'
        ? from.meta.backPath
        : RouterHelper.backPathConfig;

      if (_.isFunction(backPath)) {
        backPath = backPath(to, from);
      }

      // 有特定的返回路径，就返回到特定路径
      if (backPath && isBack && !RouterHelper.HelperBacking) {
        RouterHelper.useNextFalse(next);
        return RouterHelper.navigate(backPath); // 用navigate而不是backToPath是为了开发时方便
      }

      if (
        _.isString(RouterHelper.HelperBacking)
        && !_.includes(to.fullPath, RouterHelper.HelperBacking)
      ) {
        return next({ path: RouterHelper.HelperBacking, replace: true });
      }
    }

    return RouterHelper.useNext(next, to, from);
  });
};

const setPageTitleDebounce = debounce((to) => {
  // 展示H5导航栏时，不设置原生导航栏名称
  if (to.meta && to.meta.isShowH5Nav && platform.isHelloApp) {
    setPageTitle('');
  } else {
    setPageTitle(to.meta.title || '臻有钱');
  }
}, 100);


const addBeforeResolveGuard = (router: VueRouter): void => {
  router.beforeResolve((to, from, next) => {
    Vue.nextTick(() => {
      /**
       * beforeResolve 执行时机 在 onRouteChange 之前
       * 导致 isShowH5Nav 赋值为false时，该处判断条件还是true
       * 因此整体debounce 100ms，保证 isShowH5Nav 为最新赋值
       */
      setPageTitleDebounce(to);
    });

    // 根据当前的用户状态信息，判断pageId取值;
    const pageId = getPageIdByUser(to, to.meta) || to.meta.pageId;

    if (to.meta.pageId && !to.meta.ubtPageViewCustom) {
      const now = new Date().getTime();
      cache.set(to.meta.pageId, now);
      // 判断这个用户是否有当期或者逾期的账单需要还款，用于计算还款转化率
      ubtPage(pageId, from.meta.pageId || '', now, undefined, {
        // 当期还款
        differType: 'current',
        differValue: `${store.state.base.repayState.current}`,
        // 逾期还款
        extraType: 'overDue',
        extraValue: `${store.state.base.repayState.overDue}`,
        ...store.state.base.platformDeviceInfo,
      });
    }

    if (from.meta.pageId && !from.meta.ubtPageViewCustom) {
      ubtPage(
        from.meta.pageId,
        '',
        cache.get(from.meta.pageId),
        new Date().getTime(),
        {

          differType: 'current',
          differValue: `${store.state.base.repayState.current}`,
          extraType: 'overDue',
          extraValue: `${store.state.base.repayState.overDue}`,
        },
      );
    }

    next();
  });
};

const addAfterEachGuard = (router: VueRouter) => {
  router.afterEach((to) => {
    setTimeout(
      () => RouterHelper.updateCurrentState(to.fullPath, to.meta.siblingPaths),
      16,
    );
  });
};

// eslint-disable-next-line import/prefer-default-export
export const addNavigatoinGuard = (router: VueRouter): VueRouter => {
  if (isH5App) {
    addH5BeforeEachGuard(router);
  }

  addBeforeEachGuard(router);
  addBeforeResolveGuard(router);
  addAfterEachGuard(router);

  return router;
};
